import { render, staticRenderFns } from "./week-goals.vue?vue&type=template&id=e16fb8e8&"
import script from "./week-goals.vue?vue&type=script&lang=js&"
export * from "./week-goals.vue?vue&type=script&lang=js&"
import style0 from "./week-goals.vue?vue&type=style&index=0&id=e16fb8e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports